import { useEffect, useState } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { Toolbar, AppBar, Button, Alert } from '@mui/material';
// import { navigationViewHomepage } from '../WebAnalytics';
import logoBlue from '../../Assets/Images/Soothe-logo-blue-svg.svg';
import { HOST_ROOT } from '../../apiConfig';
function Header(props) {
    const [scrolledDown, setScrolledDown] = useState(false);
    const { hideGoBack, showMenu, width, alertType, alertMessage } = props;

    useEffect(() => {
        const handleScroll = () => {
            setScrolledDown(prev => {
                if (window.scrollY > 0 && !prev) return true;
                if (window.scrollY === 0 && prev) return false;
                return prev; // no change
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []); // only run once

    return <>
        <AppBar position="fixed" elevation={scrolledDown ? 4 : 0} className='nav-header-style br-b-opaque' color='inherit' sx={{ px: 0 }}>
            <Toolbar className={`height-80 p-16-64 align-items-center justify-content-spaced ${width < 800 ? "" : "bg-primary"}`} sx={{ px: 0, minHeight: "auto" }}>
                {!hideGoBack && !showMenu ? (
                    <div className="w-33">
                        <a href={'# '} onClick={props.relevantGoBack} className="d-flex-only align-items-center BluePrimary font-weight-bold size-18-24 deco-none">
                            <ArrowBack className="mr-12 size-18-28-imp" />
                            {' '}
                            <span className='sm-d-none'>Back</span>
                        </a>
                    </div>
                ) : null}
                {hideGoBack && !showMenu ?
                    <div className="w-33" />
                    : null}
                <div >
                    <Button
                        href={`/`}
                        id="sootheLogo"
                    >
                        <img className="height-44 sm-d-none" src={logoBlue} alt="Soothe-small" />
                    </Button>
                </div>
                <div className="w-33" />
            </Toolbar>
        </AppBar>
        <Toolbar />
        <Alert severity={alertType} sx={{
            margin: "24px 0px", width: "100%",
            ...scrolledDown ? { position: "fixed", top: "60px", left: "0px", zIndex: 1000 } : { position: "relative" },
        }}>
            {alertMessage}
        </Alert>
    </>
}

export default Header;